export const StorageKeys = {
    accessToken: 'access_token',
    user: 'user',
} as const;
